// Credits shown on the auth pages, the app shell and every PDF footer (instructor feedback, pt 9).
export const CREDITS = {
  developedBy: "Autoverso",
  conceivedBy: "Magnus Medeiros",
  contact: "autoverso.mkt@gmail.com",
  // Feedback round 3, pt 16.
  notice: "Propriedade intelectual de Autoverso. Uso autorizado desta versão apenas para ação de educação corporativa.",
} as const;
export const CREDITS_LINE = `Desenvolvido por ${CREDITS.developedBy} (${CREDITS.contact}) · Concebido por ${CREDITS.conceivedBy}`;
